import styled, {
  BoxShadows,
  type IFalconTheme,
  Scale,
  SelectVariant,
  boxShadows,
  css,
  keyframes,
} from '@secretescapes/falcon';

export const Container = styled('div')`
  display: flex;
  flex-direction: column;
  gap: ${Scale.xxs};
`;

const pulsateOutline = (theme: IFalconTheme) => keyframes`
  0% { 
    outline: ${Scale.xxxs} solid transparent;
  }
  50% { 
    outline: ${Scale.xxxs} solid ${theme.color.secondary50};
  }
  100% { 
    outline: ${Scale.xxxs} solid transparent;
  }
`;

interface StyledSelectProps {
  variant: SelectVariant;
  fixedWidth?: boolean;
  animate?: boolean;
}

export const StyledSelect = styled('div')<StyledSelectProps>`
  // If we only set percentage width, titles that has 3 lines will causing
  // inner p to grow and pushes the outer div to grow as well.
  // Therefore, to keep it stable for 3 lines of text, we're setting
  // max-width to 300px.
  ${({ fixedWidth }) => fixedWidth && `max-width: 340px;`}

  /* Pulsate animation styling */
  border-radius: ${Scale.xxs};
  margin-bottom: ${Scale.xxxs};
  ${({ animate, theme }) =>
    animate &&
    css`
      animation: ${pulsateOutline(theme)} 1.5s linear;
    `};

  div:first-child {
    min-height: ${Scale.xl};
    padding-top: 0;
    padding-bottom: 0;
    border-radius: ${Scale.xxs};
    align-items: center;

    > p {
      display: block;
      padding: ${Scale.xxs} 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    // Fixes positioning of arrow
    div > span {
      top: unset;
    }
  }

  ${({ variant }) =>
    variant === SelectVariant.dropdown &&
    css`
      li {
        border: none;
        border-radius: ${Scale.xxs};
        padding: ${Scale.xs};
      }

      ul {
        background-color: ${({ theme }) => theme.color.white};
        box-shadow: ${boxShadows[BoxShadows.level2]};
        padding: ${Scale.m};
        border-radius: ${Scale.xxs};
        box-sizing: border-box;
      }
    `};
`;

export const SelectOptionWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  padding-bottom: ${Scale.m};
  li:last-child {
    border-bottom: none;
  }
`;
